import { createFileRoute } from '@tanstack/react-router';

import { VideoItemView } from '#/features/community-hub/components/block-viewers/video-item-view';

/**
 * Video item viewer. Path: /programs/{program}/video/{itemSlug}
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/video/$itemSlug')({
  component: VideoContentRoute,
});

function VideoContentRoute() {
  const { itemSlug } = Route.useParams();
  // Keyed so opening another item remounts the view instead of keeping the last item's state.
  return <VideoItemView key={itemSlug} itemSlug={itemSlug} />;
}
